import type { CoreQuestionConfig } from '@dmp/qqms/data-access';
import type { LinearAnswer } from '@dmp/qqms/types';
import type { LinearQuestionState } from '../state/state-types';

export const convertLinearQuestionToCoreQuestionConfig = (
    cardState: LinearQuestionState,
    cardAnswers: LinearAnswer[]
): CoreQuestionConfig => {
    const { body, formType, traxexLabel, layout } = cardState;

    return {
        answers: cardAnswers,
        body,
        formType,
        traxexLabel,
        layout,
    };
};
